import { render, staticRenderFns } from "./HistoricoLancesAutomaticos.vue?vue&type=template&id=39a23be8&"
import script from "./HistoricoLancesAutomaticos.vue?vue&type=script&lang=js&"
export * from "./HistoricoLancesAutomaticos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports